import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./VerticalNavbar.module.css";
import StarLogo from "../../../assets/SVGs/logo/Logo.svg";
import ShortLogo from "../../../assets/SVGs/logo/ShortLogo.svg";
import HomeIcon from "../../../assets/SVGs/home_icon.svg";
import DocIcon from "../../../assets/SVGs/doc_icon.svg";
import UserImg from "../../../assets/images/dummyUser.jpg";

import { Button, Typography } from "@mui/material";

const VerticalNavbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [isSecondDropdownOpen, setIsSecondDropdownOpen] = useState<boolean>(false);
  const [activePage, setActivePage] = useState<string>("");
  const [showLogout, setShowLogout] = useState<boolean>(false);
  const [userImage, setUserImage] = useState<string | null>(null);
  const [imageLoading, setImageLoading] = useState<boolean>(true);
  const { instance } = useMsal();
  const role = localStorage.getItem("role");
  const manageMent = localStorage.getItem("management");

  useEffect(() => {
    setActivePage(location.pathname);
    if (
      location.pathname.includes("/operations/strategy-value-creation") ||
      location.pathname.includes("/operations/management") ||
      location.pathname.includes("/operations/people")
    ) {
      setIsDropdownOpen(true);
    } else {
      setIsDropdownOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const fetchUserImage = async () => {
      const token = localStorage.getItem("tokenKey");
      if (!token) return;

      try {
        const response = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const imageBlob = await response.blob();
          const imageUrl = URL.createObjectURL(imageBlob);
          setUserImage(imageUrl);
        } else {
          // If the request fails (404 or other error), use the default image
          setUserImage(null);
        }
      } catch (error) {
        console.error("Error fetching user image:", error);
        setUserImage(null);
      } finally {
        setImageLoading(false);
      }
    };

    fetchUserImage();

    // Clean up the object URL when component unmounts
    return () => {
      if (userImage) {
        URL.revokeObjectURL(userImage);
      }
    };
  }, []);

  const toggleNavbar = (): void => {
    setIsCollapsed((prev) => !prev);
  };

  const toggleDropdown = (): void => {
    setIsDropdownOpen((prev) => !prev);
  };
  const toggleSecondDropdown = (): void => {
    setIsSecondDropdownOpen((prev) => !prev);
  };

  // const handleLogout = (): void => {
  //   localStorage.removeItem("accessToken");
  //   navigate("/login");
  // };

  const handleLogout = (): void => {
    // Clear local storage
    localStorage.clear();

    // Clear session storage
    sessionStorage.clear();

    // MSAL logout
    // instance.logoutRedirect({
    //   postLogoutRedirectUri: "/login",
    // });

    // Clear all local storage
    localStorage.removeItem("accessToken");
    localStorage.removeItem("tokenKey");
    localStorage.removeItem("roleKey");
    localStorage.removeItem("userName");
    localStorage.removeItem("apiManagement");
    localStorage.removeItem("role");

    // Use MSAL to properly logout
    instance.logoutRedirect({
      postLogoutRedirectUri: "/login",  // Redirect to login page after logout
    }).catch(error => {
      console.error("Logout failed:", error);
      // Fallback to manual navigation if logout fails
      navigate("/login");
    });
  };

  return (
    <div className={`${styles.navContainer} ${isCollapsed ? styles.collapsed : ""}`}>
      <div className={styles.logoDiv}>
        <img src={isCollapsed ? ShortLogo : StarLogo} height={50} alt="Logo" />
      </div>

      <div className={styles.navItems}>
        <Link to="/" className={`${styles.navItem} ${activePage === "/" ? styles.active : ""}`}>
          <img src={HomeIcon} alt="Home" />
          {!isCollapsed && <span>Home</span>}
        </Link>

        <Link to="/dashboard" className={`${styles.navItem} ${activePage === "/dashboard" ? styles.active : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g opacity="0.5">
<path d="M6.66667 2.71606H2V7.38273H6.66667V2.71606Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 2.71606H9.33334V7.38273H14V2.71606Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 10.0493H9.33334V14.716H14V10.0493Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66667 10.0493H2V14.716H6.66667V10.0493Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
          {!isCollapsed && <span>Dashboard</span>}
        </Link>
        {/* <Link to="/result-dashboard" className={`${styles.navItem} ${activePage === "/result-dashboard" ? styles.active : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 22 30" fill="none">
        <g opacity="0.5">
<path d="M8.483 0C6.8407 0 5.489 1.3544 5.489 3V4C5.489 5.6456 6.84069 7 8.483 7H14.471C16.1133 7 17.465 5.6456 17.465 4V3C17.465 1.3544 16.1133 0 14.471 0H8.483ZM8.483 2H14.471C15.0334 2 15.469 2.43647 15.469 3V4C15.469 4.56352 15.0334 5 14.471 5H8.483C7.92061 5 7.485 4.56352 7.485 4V3C7.485 2.43647 7.9206 2 8.483 2Z" fill="white"/>
<path d="M2.994 2C2.20003 2 1.43856 2.3164 0.877148 2.87891C0.31577 3.44144 0 4.20444 0 5V25C0 25.7955 0.315619 26.5585 0.877148 27.1211C1.4385 27.6834 2.19993 28 2.994 28H19.96C20.7541 28 21.5155 27.6836 22.0769 27.1211C22.6382 26.5586 22.954 25.7956 22.954 25V5C22.954 4.20433 22.6381 3.44138 22.0769 2.87891C21.5154 2.31625 20.754 2 19.96 2H16.966C16.7014 2.00029 16.4477 2.10574 16.2606 2.29321C16.0735 2.48069 15.9683 2.73487 15.968 3C15.9683 3.26513 16.0735 3.51931 16.2606 3.70679C16.4477 3.89426 16.7014 3.99971 16.966 4H19.96C20.2247 4 20.4786 4.1055 20.6656 4.29297C20.8529 4.48065 20.958 4.73479 20.958 5V25C20.958 25.2652 20.8527 25.5195 20.6656 25.707C20.4785 25.8945 20.2246 26 19.96 26H2.994C2.72932 26 2.47569 25.8947 2.28838 25.707C2.10129 25.5196 1.996 25.2653 1.996 25V5C1.996 4.73469 2.10114 4.48059 2.28838 4.29297C2.47563 4.10535 2.72922 4 2.994 4H5.988C6.2526 3.99971 6.50628 3.89426 6.69337 3.70679C6.88047 3.51931 6.98571 3.26513 6.986 3C6.98571 2.73487 6.88047 2.48069 6.69337 2.29321C6.50628 2.10574 6.2526 2.00029 5.988 2H2.994Z" fill="white"/>
<path d="M17.0674 11.199C16.9624 11.12 16.843 11.0624 16.7158 11.0296C16.5887 10.9968 16.4564 10.9895 16.3264 11.008C16.1964 11.0265 16.0713 11.0705 15.9583 11.1374C15.8453 11.2044 15.7466 11.293 15.6678 11.3982L10.2451 18.6404L8.03857 17.1678C7.81826 17.021 7.54882 16.9677 7.28937 17.0197C7.02991 17.0717 6.80164 17.2247 6.65463 17.4451C6.5081 17.6659 6.45496 17.9358 6.50685 18.1958C6.55874 18.4558 6.71143 18.6845 6.93142 18.8318L9.92542 20.8318C10.1376 20.9737 10.396 21.0289 10.6475 20.9861C10.899 20.9432 11.1247 20.8056 11.2782 20.6014L17.2662 12.6014C17.3451 12.4962 17.4025 12.3765 17.4352 12.2491C17.4679 12.1217 17.4753 11.9891 17.4568 11.8589C17.4383 11.7287 17.3944 11.6034 17.3276 11.4901C17.2608 11.3769 17.1724 11.278 17.0674 11.199Z" fill="white"/>
</g>
</svg>
          {!isCollapsed && <span>Result</span>}
        </Link> */}

 
        <div className={`${styles.navItem} ${isSecondDropdownOpen ? styles.active : ""}`} onClick={toggleSecondDropdown}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 22 30" fill="none">
        <g opacity="0.5">
<path d="M8.483 0C6.8407 0 5.489 1.3544 5.489 3V4C5.489 5.6456 6.84069 7 8.483 7H14.471C16.1133 7 17.465 5.6456 17.465 4V3C17.465 1.3544 16.1133 0 14.471 0H8.483ZM8.483 2H14.471C15.0334 2 15.469 2.43647 15.469 3V4C15.469 4.56352 15.0334 5 14.471 5H8.483C7.92061 5 7.485 4.56352 7.485 4V3C7.485 2.43647 7.9206 2 8.483 2Z" fill="white"/>
<path d="M2.994 2C2.20003 2 1.43856 2.3164 0.877148 2.87891C0.31577 3.44144 0 4.20444 0 5V25C0 25.7955 0.315619 26.5585 0.877148 27.1211C1.4385 27.6834 2.19993 28 2.994 28H19.96C20.7541 28 21.5155 27.6836 22.0769 27.1211C22.6382 26.5586 22.954 25.7956 22.954 25V5C22.954 4.20433 22.6381 3.44138 22.0769 2.87891C21.5154 2.31625 20.754 2 19.96 2H16.966C16.7014 2.00029 16.4477 2.10574 16.2606 2.29321C16.0735 2.48069 15.9683 2.73487 15.968 3C15.9683 3.26513 16.0735 3.51931 16.2606 3.70679C16.4477 3.89426 16.7014 3.99971 16.966 4H19.96C20.2247 4 20.4786 4.1055 20.6656 4.29297C20.8529 4.48065 20.958 4.73479 20.958 5V25C20.958 25.2652 20.8527 25.5195 20.6656 25.707C20.4785 25.8945 20.2246 26 19.96 26H2.994C2.72932 26 2.47569 25.8947 2.28838 25.707C2.10129 25.5196 1.996 25.2653 1.996 25V5C1.996 4.73469 2.10114 4.48059 2.28838 4.29297C2.47563 4.10535 2.72922 4 2.994 4H5.988C6.2526 3.99971 6.50628 3.89426 6.69337 3.70679C6.88047 3.51931 6.98571 3.26513 6.986 3C6.98571 2.73487 6.88047 2.48069 6.69337 2.29321C6.50628 2.10574 6.2526 2.00029 5.988 2H2.994Z" fill="white"/>
<path d="M17.0674 11.199C16.9624 11.12 16.843 11.0624 16.7158 11.0296C16.5887 10.9968 16.4564 10.9895 16.3264 11.008C16.1964 11.0265 16.0713 11.0705 15.9583 11.1374C15.8453 11.2044 15.7466 11.293 15.6678 11.3982L10.2451 18.6404L8.03857 17.1678C7.81826 17.021 7.54882 16.9677 7.28937 17.0197C7.02991 17.0717 6.80164 17.2247 6.65463 17.4451C6.5081 17.6659 6.45496 17.9358 6.50685 18.1958C6.55874 18.4558 6.71143 18.6845 6.93142 18.8318L9.92542 20.8318C10.1376 20.9737 10.396 21.0289 10.6475 20.9861C10.899 20.9432 11.1247 20.8056 11.2782 20.6014L17.2662 12.6014C17.3451 12.4962 17.4025 12.3765 17.4352 12.2491C17.4679 12.1217 17.4753 11.9891 17.4568 11.8589C17.4383 11.7287 17.3944 11.6034 17.3276 11.4901C17.2608 11.3769 17.1724 11.278 17.0674 11.199Z" fill="white"/>
</g>
</svg>
  {!isCollapsed && <span>Result</span>}
  {isSecondDropdownOpen ? (
    <KeyboardArrowUpIcon sx={{ color: "#fff" }} />
  ) : (
    <ExpandMoreIcon sx={{ color: "#fff" }} />
  )}
</div>

{isSecondDropdownOpen && (
  <div className={`${styles.dropdownMenu} ${isCollapsed ? styles.collapsedDropdown : ""}`}>
    <div className={styles.dropdownItemscollapsed}>
      <Link
        style={{ paddingLeft: "40px" }}
        to="/result-dashboard"
        className={`${styles.navItem} ${activePage.includes("/result-dashboard") ? styles.activeSub : ""}`}
      >
        <span>Score Sheet</span>
      </Link>
      {/* <Link
        style={{ paddingLeft: "40px" }}
        to="/result-deepdive"
        className={`${styles.navItem} ${activePage.includes("/result-deepdive") ? styles.activeSub : ""}`}
      >
        <span>Results - Deep Dive</span>
      </Link> */}
      {/* <Link
        style={{ paddingLeft: "40px" }}
        to="/"
        className={`${styles.navItem} ${activePage.includes("/") ? styles.activeSub : ""}`}
      >
        <span>Means - Action Log</span>
      </Link>
      <Link
        style={{ paddingLeft: "40px" }}
        to="/"
        className={`${styles.navItem} ${activePage.includes("/") ? styles.activeSub : ""}`}
      >
        <span>Audit Checklist</span>
      </Link> */}
    </div>
  </div>
)}



        <div className={`${styles.navItem} ${isDropdownOpen ? styles.active : ""}`} onClick={toggleDropdown}>
          <img src={DocIcon} alt="Evidence Upload" />
          {!isCollapsed && <span>Q2 Evidence Uploads</span>}
          {isDropdownOpen ? <KeyboardArrowUpIcon sx={{ color: "#fff" }} /> : <ExpandMoreIcon sx={{ color: "#fff" }} />}
        </div>

        {isDropdownOpen && (
          <div className={`${styles.dropdownMenu} ${isCollapsed ? styles.collapsedDropdown : ""}`}>
            <div className={styles.dropdownItemscollapsed}>
              <Link style={{ paddingLeft: "40px" }} to="/operations/strategy-value-creation" className={`${styles.navItem} ${activePage.includes("/operations/strategy-value-creation") ? styles.activeSub : ""}`}>
                <span>Strategy & Value Creation</span>
              </Link>
              <Link
                style={{ paddingLeft: "40px" }}
                to="/operations/management"
                className={`${styles.navItem} ${activePage.includes("/operations/management") || activePage.includes("/operations/people")
                  ? styles.activeSub
                  : ""
                  }`}
              >
                <span>Operations</span>
              </Link>
            </div>
          </div>
        )}



{role === 'super_admin' && (<Link to="/feedback" className={`${styles.navItem} ${activePage === "/feedback" ? styles.active : ""}`}>
           {/* <img src={HomeIcon} alt="Home" />  */}
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 19 19" fill="none">
            <g opacity="0.5">
              <path d="M13.3333 5.38258H2.66659C1.93021 5.38258 1.33325 5.97954 1.33325 6.71592V13.3826C1.33325 14.119 1.93021 14.7159 2.66659 14.7159H13.3333C14.0696 14.7159 14.6666 14.119 14.6666 13.3826V6.71592C14.6666 5.97954 14.0696 5.38258 13.3333 5.38258Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10.6666 14.7159V4.04925C10.6666 3.69562 10.5261 3.35648 10.2761 3.10644C10.026 2.85639 9.68687 2.71591 9.33325 2.71591H6.66659C6.31296 2.71591 5.97383 2.85639 5.72378 3.10644C5.47373 3.35648 5.33325 3.69562 5.33325 4.04925V14.7159" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
            </g>
          </svg>
          {!isCollapsed && <span>  Review and Feedback</span>}
        </Link>)}



        <Link to="/help" className={`${styles.navItem} ${activePage === "/help" ? styles.active : ""}`}>
          {/* <img src={HomeIcon} alt="Home" /> */}
          <svg xmlns="http://www.w3.org/2000/svg"  width="22" height="22" viewBox="0 0 16 16" fill="none">
<g opacity="0.5" clip-path="url(#clip0_10140_50466)">
<path d="M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.06006 5.99989C6.21679 5.55434 6.52616 5.17863 6.93336 4.93931C7.34056 4.7 7.81932 4.61252 8.28484 4.69237C8.75036 4.77222 9.1726 5.01424 9.47678 5.37558C9.78095 5.73691 9.94743 6.19424 9.94672 6.66656C9.94672 7.99989 7.94673 8.66656 7.94673 8.66656" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 11.3335H8.00667" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_10140_50466">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
          {!isCollapsed && <span> Help</span>}
        </Link>

      </div>

      <div className={styles.userDiv}>
        {showLogout ? (
          <Button variant="contained" sx={{ mt: 1, bgcolor: "#fff", color: "#000" }} onClick={handleLogout}>
            Logout
          </Button>
        ) : (
          <div style={{ display: 'flex', gap: '8px' }}>
            {imageLoading ? (
              <div style={{ width: '40px', height: '40px', backgroundColor: '#ccc', borderRadius: '50%' }} />
            ) : (
              <img
                src={userImage || UserImg}
                alt="User"
                style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
                onError={(e) => {
                  // Fallback to default image if the fetched image fails to load
                  const target = e.target as HTMLImageElement;
                  target.src = UserImg;
                }}
              />
            )}
            {!isCollapsed && (
              <div>
                <p className={styles.username}>{localStorage.getItem("userName")}</p>
                <p style={{ color: '#fff', fontSize: '12px', paddingTop: '5px' }}>{manageMent}</p>
                <p style={{ color: '#fff', fontSize: '12px', paddingTop: '8px' }}>
                  {localStorage.getItem("role")}
                </p>
              </div>
            )}
          </div>
        )}
        <MoreVertIcon sx={{ color: "#fff", cursor: "pointer" }} onClick={() => setShowLogout((prev) => !prev)} />
      </div>

      <div className={styles.toggleButton} onClick={toggleNavbar}>
        {isCollapsed ? <ArrowForwardIosIcon sx={{ color: "#fff" }} /> : <ArrowBackIosNewIcon sx={{ color: "#fff" }} />}
      </div>
    </div>
  );
};

export default VerticalNavbar;